import { createSlice } from "@reduxjs/toolkit";
import { dispatch, RootState } from "../store";
import { IAOPR, IAOR, ISubBrokerUser } from "../../Types/AccountOpeningRequest";
import lsu from "../../Services/LocalStorageUtils";
import { IOTPSession } from "../../Types/OTPSession";
import { reset } from "./registration";
import AuthInfoContext from "../../Types/AuthInfoContext";
import api from "../../Services/ApiServices";
import { IInitialQueryParams } from "../../Types/AllTypes";

interface ICartState {
  isLoading: boolean;
  objAOPR: IAOPR | null;
  objSubBrokerUser: ISubBrokerUser | null;
  objAOR: IAOR | null;
  objAuthInfoResponse: IOTPSession | null;
  objAuthContext?: AuthInfoContext;
  error: any;
  stage: number;
  initialQueryParams?: IInitialQueryParams;
  isSubBrokerLoading?: boolean;
}

const initialState: ICartState = {
  isLoading: false,
  error: null,
  objAOPR: lsu.lsGet("common.objAOPR") || null,
  objSubBrokerUser: lsu.lsGet("common.objSubBrokerUser") || null,
  objAuthInfoResponse: lsu.lsGet("common.objAuthInfoResponse") || null,
  objAuthContext: lsu.lsGet("common.objAuthContext") || null,
  objAOR: lsu.lsGet("common.objAOR") || null,
  stage: lsu.lsGet("common.stage") || 0,
  initialQueryParams: lsu.lsGet("common.initialQueryParams"),
};

const LS_EXPIRE_AFTER: any = 30;

const slice = createSlice({
  name: "common",
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
    },
    setSelectedAOPR(state, action) {
      state.objAOPR = action.payload;
      updateLocalStorage(state);
    },
    setSubbrokerUser(state, action) {
      state.objSubBrokerUser = action.payload;
      updateLocalStorage(state);
    },
    setSelectedAOR(state, action) {
      state.objAOR = action.payload;
      updateLocalStorage(state);
    },
    setAuthInfo(state, action) {
      const { MemoryBag, ...payload } = action.payload;
      state.objAuthInfoResponse = payload;
      state.objAuthContext = new AuthInfoContext(
        payload?.ContextSystemObjectIDOrCode
      );
      updateLocalStorage(state);
    },
    setStage(state, action) {
      state.stage = action.payload;
      updateLocalStorage(state);
    },
    setInitialQueryParams(state, action) {
      state.initialQueryParams = action.payload;
      updateLocalStorage(state);
    },
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    setSubBrokerLoading(state, action) {
      state.isSubBrokerLoading = action.payload;
    },
    resetFields() {
      return {
        isLoading: false,
        error: null,
        objAOPR: null,
        objAuthInfoResponse: null,
        objAOR: null,
        objSubBrokerUser: null,
        stage: 0,
      };
    },
  },
});

// export const setCartDrawerOpen = slice.actions.setDrawerOpen;
// Reducer
export default slice.reducer;

export const {
  setSelectedAOPR,
  setStage,
  setSelectedAOR,
  setAuthInfo,
  setInitialQueryParams,
} = slice.actions;

// Obsolute. Not called from anywhere
export const loadAOPR = (AOPRID: number, AOPRUID: string) => {
  // OR BPC then i need to call this API 10558100 AOPRID,AOPRUID,BPC Paramater
  return async (dis: any, getState: () => RootState) => {
    try {
      const response = await api.fetchPrefilledRequest({ AOPRID, AOPRUID });

      // 2  thing

      // show subbroker logo beside the RW logo

      //   public string MobileNumber = string.Empty;
      //   public bool CanEdit = false; // is true then and then we should provide read only
      //   public string SubbrokerLogoURL = string.Empty;
      //   public string RMCode = string.Empty;
      //   public string RMName = string.Empty

      //   96 use material ui  amd swap the mock field first radio and second input
      //             disabled={!objStage6Info?.CanEditStage}

      // 98 if i get can edit false then readonly all field. show query box if get any kind of quesry
      // 99 if i get canEdit false  checked and readonly checkbox

      // 101 canEdit than mobile can edit canEditEmail false then readOnly

      // 102 if i getCanEdit False then hide ReUpload button.

      // 103 AccountOpeningDocumentStatusInternalCode 2 Authorized then show Green color status Document is Approvved

      // 3.1 Remove Gender Field

      if (response.Records && response.Records[0]) {
        await dispatch(slice.actions.resetFields());
        await dispatch(slice.actions.setSelectedAOPR(response.Records[0]));
      }
    } catch (ex) {
      dispatch(slice.actions.hasError(ex));
    }
  };
};

export const fetchSubBrokerDetails = (
  AOPRID: number = 0,
  AOPRUID: string = "",
  BPC: string = ""
) => {
  return async (dis: any, getState: () => RootState) => {
    try {
      const response = await api.fetchSubBrokerDetails({
        AOPRID,
        AOPRUID,
        BPC,
      });

      if (response.Status) {
        await dispatch(slice.actions.setSubbrokerUser(response));
      } else {
        dispatch(slice.actions.hasError(response.Message));
      }
    } catch (ex) {
      dispatch(slice.actions.hasError(ex));
    }
  };
};

export const fetchSubBrokerDetailsFromBPC = (BPC: string = "") => {
  return async (dis: any, getState: () => RootState) => {
    try {
      await dispatch(slice.actions.setSubBrokerLoading(true));
      const response = await api.fetchSubBrokerDetails({
        AOPRID: 0,
        AOPRUID: "",
        BPC,
      });

      if (response.Status) {
        await dispatch(
          slice.actions.setSubbrokerUser({ ...response, __BPC: BPC })
        );
      } else {
        await dispatch(slice.actions.setSubbrokerUser(undefined));
      }
    } catch (ex) {
    } finally {
      await dispatch(slice.actions.setSubBrokerLoading(false));
    }
  };
};

export const logOutAndResetFields = () => {
  return async () => {
    try {
      lsu.lsDelete("common.objAOPR");
      lsu.lsDelete("common.objAOR");
      lsu.lsDelete("common.objAuthInfoResponse");
      lsu.lsDelete("common.stage");
      lsu.lsDelete("common.objAuthContext");
      lsu.lsDelete("common.initialQueryParams");
      lsu.lsDelete("common.objSubBrokerUser");
      dispatch(slice.actions.resetFields());
      dispatch(reset());
    } catch (ex) {
      console.log("Error occurred while logging out: ", ex);
    }
  };
};

function updateLocalStorage(state: any) {
  lsu.lsSet("common.objAOPR", state.objAOPR, LS_EXPIRE_AFTER);
  lsu.lsSet("common.objAOR", state.objAOR, LS_EXPIRE_AFTER);
  lsu.lsSet("common.objSubBrokerUser", state.objSubBrokerUser, LS_EXPIRE_AFTER);
  lsu.lsSet(
    "common.objAuthInfoResponse",
    state.objAuthInfoResponse,
    LS_EXPIRE_AFTER
  );
  lsu.lsSet("common.objAuthContext", state.objAuthContext, LS_EXPIRE_AFTER);
  lsu.lsSet("common.stage", state.stage, LS_EXPIRE_AFTER);
  lsu.lsSet(
    "common.initialQueryParams",
    state.initialQueryParams,
    LS_EXPIRE_AFTER
  );
}

// @ts-ignore
window.setAuthInfo = (obj: any) => {
  dispatch(setAuthInfo(obj));
};
